<template>
  <div class="depot-documents">
    <header
      class="depot-documents__header"
      @click="isUploadFichierOpen = !isUploadFichierOpen"
    >
      <BasicText weight="bold">Documents à transmettre (Assurez-vous d’avoir signé tous les documents qui peuvent l’être)</BasicText>
      <BasicAlert
        v-if="nombreFichiersObligatoires > 0"
        :alertType="alertModel.type"
        :alert-label="alertModel.message"
        :has-bg="false"
      />
      <BasicIcon
        class="toggle-arrow"
        name="arrow-down"
      />
    </header>
    <div
      class="depot-documents__content"
      v-if="isUploadFichierOpen"
    >
      <UploadNature
        v-for="nature in naturesFichiersAffichées"
        :key="nature"
        :nature
      >
        <template #header-nature="natureModel">
          <slot
            name="header-nature"
            v-bind="natureModel"
          ></slot>
        </template>
        <template #footer-nature="natureModel">
          <slot
            name="footer-nature"
            v-bind="natureModel"
          ></slot>
        </template>
      </UploadNature>
    </div>
  </div>

  <BasicDropdownButton
    v-if="!readonly"
    label="Ajouter un fichier"
    :items="lovFichiersFacultatifs"
    key-id="code"
    key-label="intitule"
    @select-item="(code: string) => ajouteNature(code)"
    :disabled="lovFichiersFacultatifs.length === 0"
    style="width: 250px"
  />
</template>

<script setup lang="ts">
  import type { AlertType } from '@designSystem/components'
import { computed, inject } from 'vue'
import { UPLOAD_FICHIER_INJECT } from './constants'
import type { UseUploadFichiersResult } from './UploadFichiers.types'
import UploadNature from './UploadNature.vue'

  const uploadFichiers = inject<UseUploadFichiersResult>(UPLOAD_FICHIER_INJECT)!
  const {
    readonly,
    isUploadFichierOpen,
    nombreFichiersObligatoires,
    nombreFichiersObligatoiresChargés,
    naturesFichiersAffichées,
    natureRecordFacultatifs,
    ajouteNature,
  } = uploadFichiers

  const alertModel = computed(() => {
    const message = `${nombreFichiersObligatoiresChargés.value}/${nombreFichiersObligatoires.value} types de documents obligatoires à transmettre`
    const type: AlertType =
      nombreFichiersObligatoires.value === nombreFichiersObligatoiresChargés.value ? 'success' : 'danger'
    return {
      message,
      type,
    }
  })

  const lovFichiersFacultatifs = computed(() =>
    Object.keys(natureRecordFacultatifs.value).map((nature) => natureRecordFacultatifs.value[nature]),
  )
</script>
<style scoped lang="less">
  .depot-documents {
    padding: 16px;
    display: flex;
    flex-direction: column;
    border: 1px @neutral-200 solid;
    border-radius: 8px;
    gap: 16px;

    &__header {
      display: flex;
      position: relative;
      flex-direction: column;
      cursor: pointer;

      .toggle-arrow {
        fill: @primary-600;
        position: absolute;
        top: -5px;
        right: 0px;
        transform: rotate(180deg);
        transition: transform 0.3s;
      }
    }

    &:has(> &__content) {
      .toggle-arrow {
        transform: rotate(0);
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      gap: @spacing-25;
    }
  }
</style>
